// extracted by mini-css-extract-plugin
export default {"container":"TextEditorMenu_container__I9mJ3","active":"TextEditorMenu_active__ngisV"};